import { render, staticRenderFns } from "./MedicalWritingReport.vue?vue&type=template&id=cfb3d952&"
import script from "./MedicalWritingReport.vue?vue&type=script&lang=js&"
export * from "./MedicalWritingReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports